/**
 * Decimal 工具（Issue #198）。
 *
 * 红线：客户端展示与简单加减必须使用 decimal.js 字符串处理，
 *       禁止 Number()、parseFloat()、'+' 直接参与计算。
 */
import { Decimal } from 'decimal.js';

Decimal.set({ precision: 28, rounding: Decimal.ROUND_HALF_EVEN });

export type DecimalString = string;

export function toDecimal(value: DecimalString | Decimal): Decimal {
  if (value instanceof Decimal) return value;
  return new Decimal(value);
}

export function formatMoneyCNY(value: DecimalString | null | undefined): string {
  if (value === null || value === undefined || value === '') return '—';
  try {
    const d = new Decimal(value);
    return `¥${d.toFixed(2)}`;
  } catch {
    return '—';
  }
}

export function add(a: DecimalString, b: DecimalString): DecimalString {
  return new Decimal(a).plus(new Decimal(b)).toString();
}

export function subtract(a: DecimalString, b: DecimalString): DecimalString {
  return new Decimal(a).minus(new Decimal(b)).toString();
}
